module.exports = __webpack_public_path__ + "img/slide-7.57fa52c0.png";